import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'เมนู',
    isTitle: true,
    roleIds: [1, 2, 3, 4],
  },
  {
    label: 'การรายงานข้อมูล',
    icon: 'home',
    link: '/dashboard',
    roleIds: [1, 2, 3, 4],
  },
  {
    label: 'แฟ้มเอกสาร',
    icon: 'folder',
    link: '/folder',
    roleIds: [1, 2, 3, 4],
  },
  {
    label: 'หมวดหมู่เอกสาร',
    icon: 'align-justify',
    link: '/document-type',
    roleIds: [1, 2, 3, 4],
  },
  {
    label: 'เอกสาร',
    icon: 'book',
    link: '/document',
    roleIds: [1, 2, 3, 4],
  },
  {
    label: 'ไฟล์',
    icon: 'file',
    link: '/file',
    roleIds: [1, 2, 3, 4],
  },
  {
    label: 'จัดการสิทธิ์',
    icon: 'shield',
    link: '/permission',
    roleIds: [1],
  },
];
